import React from 'react'

export default function EventTipsCard() {
  return (
    <div className="flex flex-col gap-6">
      {/* ── Card 1: Event Guidelines ── */}
      <div className="rounded-3xl border border-outline-variant/30 bg-surface-container-lowest p-6 shadow-xs">
        <div className="flex items-center gap-3 border-b border-outline-variant/15 pb-4 mb-4">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <span className="material-symbols-outlined text-lg">lightbulb</span>
          </div>
          <div>
            <h3 className="font-display text-sm font-bold text-on-surface">
              Event Publishing Guidelines
            </h3>
            <p className="text-[11px] text-on-surface-variant">Best practices for scheduling events</p>
          </div>
        </div>

        <ul className="flex flex-col gap-3.5 text-xs text-on-surface-variant leading-relaxed">
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              check_circle
            </span>
            <span>
              <strong className="text-on-surface">Target Scope:</strong> Use <span className="font-bold text-primary">Single</span> for batch-specific symposiums, or <span className="font-bold text-primary">All</span> for institute-wide annual days and webinars.
            </span>
          </li>
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              schedule
            </span>
            <span>
              <strong className="text-on-surface">Timely Scheduling:</strong> Schedule events at least 48 hours in advance so students and parents receive calendar synchronizations.
            </span>
          </li>
          <li className="flex items-start gap-2.5">
            <span className="material-symbols-outlined text-primary text-base mt-0.5 shrink-0">
              feed
            </span>
            <span>
              <strong className="text-on-surface">Event Particulars:</strong> Include venue details, dress codes, speaker names, and online meeting links in the Particulars area.
            </span>
          </li>
        </ul>
      </div>

      {/* ── Card 2: Quick Keyboard Shortcuts ── */}
      {/* <div className="rounded-3xl border border-outline-variant/30 bg-surface-container-lowest p-6 shadow-xs">
        <div className="flex items-center gap-2 text-xs font-bold text-on-surface uppercase tracking-wider mb-3">
          <span className="material-symbols-outlined text-sm text-primary">keyboard</span>
          <span>Keyboard Shortcuts</span>
        </div>
        <div className="grid grid-cols-2 gap-2 text-[11px] text-on-surface-variant">
          <div className="flex items-center justify-between rounded-xl bg-surface-container-low px-3 py-2">
            <span>Save Event</span>
            <kbd className="rounded bg-surface-container-high px-1.5 py-0.5 text-[10px] font-mono font-bold text-on-surface">Alt + S</kbd>
          </div>
          <div className="flex items-center justify-between rounded-xl bg-surface-container-low px-3 py-2">
            <span>Cancel</span>
            <kbd className="rounded bg-surface-container-high px-1.5 py-0.5 text-[10px] font-mono font-bold text-on-surface">Alt + C</kbd>
          </div>
        </div>
      </div> */}
    </div>
  )
}
